const { createAction } = require("../helpers");
const {
  GET_ICD_LIST_DOCTOR,
  GET_ICD_LIST_DOCTOR_SUCCESS,
  GET_ICD_LIST_DOCTOR_ERROR,
  GET_ICD_LIST_DOCTOR_RESET,

  GET_ICD_LIST,
  GET_ICD_LIST_SUCCESS,
  GET_ICD_LIST_ERROR,
  GET_ICD_LIST_RESET,

  GET_ICD,
  GET_ICD_SUCCESS,
  GET_ICD_ERROR,
  GET_ICD_RESET,

  CREATE_ICD,
  CREATE_ICD_SUCCESS,
  CREATE_ICD_ERROR,
  CREATE_ICD_RESET,

  UPDATE_ICD,
  UPDATE_ICD_SUCCESS,
  UPDATE_ICD_ERROR,
  UPDATE_ICD_RESET,

  DELETE_ICD,
  DELETE_ICD_SUCCESS,
  DELETE_ICD_ERROR,
  DELETE_ICD_RESET,
} = require("./constants");

// eslint-disable-next-line max-len
const getIcdDoctorList = ({ take, skip, search }) =>
  createAction(GET_ICD_LIST_DOCTOR, { skip, take, search });
const getIcdDoctorListSuccess = (data) =>
  createAction(GET_ICD_LIST_DOCTOR_SUCCESS, { data });
const getIcdDoctorListError = (error) =>
  createAction(GET_ICD_LIST_DOCTOR_ERROR, { error });
const getIcdDoctorListReset = () => createAction(GET_ICD_LIST_DOCTOR_RESET);

// eslint-disable-next-line max-len
const getIcdList = ({ take, skip, search }) =>
  createAction(GET_ICD_LIST, { skip, take, search });
const getIcdListSuccess = (data) =>
  createAction(GET_ICD_LIST_SUCCESS, { data });
const getIcdListError = (error) => createAction(GET_ICD_LIST_ERROR, { error });
const getIcdListReset = () => createAction(GET_ICD_LIST_RESET);

const getIcd = (id) => createAction(GET_ICD, { id });
const getIcdSuccess = (data) => createAction(GET_ICD_SUCCESS, { data });
const getIcdError = (error) => createAction(GET_ICD_ERROR, { error });
const getIcdReset = () => createAction(GET_ICD_RESET);

const createIcd = (icdData) => createAction(CREATE_ICD, { icdData });
const createIcdSuccess = (data) => createAction(CREATE_ICD_SUCCESS, { data });
const createIcdError = (error) => createAction(CREATE_ICD_ERROR, { error });
const createIcdReset = () => createAction(CREATE_ICD_RESET);

const updateIcd = ({ id, icdData }) =>
  createAction(UPDATE_ICD, { id, icdData });
const updateIcdSuccess = (data) => createAction(UPDATE_ICD_SUCCESS, { data });
const updateIcdError = (error) => createAction(UPDATE_ICD_ERROR, { error });
const updateIcdReset = () => createAction(UPDATE_ICD_RESET);

const deleteIcd = ({ id }) => createAction(DELETE_ICD, { id });
const deleteIcdSuccess = (data) => createAction(DELETE_ICD_SUCCESS, { data });
const deleteIcdError = (error) => createAction(DELETE_ICD_ERROR, { error });
const deleteIcdReset = () => createAction(DELETE_ICD_RESET);

module.exports = {
  getIcdDoctorList,
  getIcdDoctorListSuccess,
  getIcdDoctorListError,
  getIcdDoctorListReset,
  getIcdList,
  getIcdListSuccess,
  getIcdListError,
  getIcdListReset,
  getIcd,
  getIcdSuccess,
  getIcdError,
  getIcdReset,
  createIcd,
  createIcdSuccess,
  createIcdError,
  createIcdReset,
  updateIcd,
  updateIcdSuccess,
  updateIcdError,
  updateIcdReset,
  deleteIcd,
  deleteIcdSuccess,
  deleteIcdError,
  deleteIcdReset,
};
